import React from "react";
import useTranslation from "../../i18n/useTranslation";

export const DIVISION_STATUS_FILTERS = {
    ALL: "all",
    OPEN: "open",
    CLOSED: "closed",
};

export default function DivisionStatusFilter({ value, onChange, disabled = false }) {
    const { t } = useTranslation();

    return (
        <label
            className="kbola-division-status-filter"
            style={{
                display: "inline-flex",
                alignItems: "center",
                gap: 8,
                margin: 0,
            }}
        >
            <span className="sr-only">{t("divisions.filterByStatus")}</span>
            <i className="fas fa-filter" aria-hidden="true" />
            <select
                className="form-control"
                style={{
                    width: "auto",
                    minWidth: 130,
                    borderRadius: 12,
                    fontWeight: 800,
                }}
                value={value}
                onChange={(event) => onChange(event.target.value)}
                disabled={disabled}
                aria-label={t("divisions.filterByStatus")}
            >
                <option value={DIVISION_STATUS_FILTERS.ALL}>
                    {t("divisions.allStatuses")}
                </option>
                <option value={DIVISION_STATUS_FILTERS.OPEN}>
                    {t("divisions.open")}
                </option>
                <option value={DIVISION_STATUS_FILTERS.CLOSED}>
                    {t("divisions.closed")}
                </option>
            </select>
        </label>
    );
}
